"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _CetComponentsProvider = require("../../../providers/CetComponentsProvider");
var _hooks = require("../../../hooks");
var useStyles = function useStyles(isMobileView, withPageSectionSeparator, pageSectionBackgroundColor) {
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    fontFamily = _useContext.fontFamily,
    basicFontSize = _useContext.basicFontSize,
    themeColors = _useContext.themeColors;
  var _useStylesUtils = (0, _hooks.useStylesUtils)(),
    pxToRem = _useStylesUtils.pxToRem;
  var ccPageStyle = (0, _react.useMemo)(function () {
    var ccPage = (0, _css.css)({
      fontFamily: fontFamily,
      fontSize: basicFontSize,
      position: 'relative',
      overflow: 'hidden',
      boxSizing: 'border-box',
      marginBottom: pxToRem(isMobileView ? 60 : 180),
      padding: isMobileView ? "".concat(pxToRem(27), " 0") : "".concat(pxToRem(48), " 0 ").concat(pxToRem(32), " 0")
    });
    var ccPageSection = (0, _css.css)({
      padding: isMobileView ? "".concat(pxToRem(Boolean(withPageSectionSeparator && pageSectionBackgroundColor) ? 20 : 0), " ").concat(pxToRem(20), " ").concat(pxToRem(20), " ").concat(pxToRem(20)) : "".concat(pxToRem(Boolean(withPageSectionSeparator && pageSectionBackgroundColor) ? 32 : 0), " ").concat(pxToRem(32), " ").concat(pxToRem(withPageSectionSeparator ? 20 : 32), " ").concat(pxToRem(32)),
      marginBottom: Boolean(withPageSectionSeparator || pageSectionBackgroundColor) ? pxToRem(isMobileView ? 20 : 32) : undefined,
      boxShadow: withPageSectionSeparator ? "0 ".concat(pxToRem(9), " ").concat(pxToRem(7), " ").concat(themeColors === null || themeColors === void 0 ? void 0 : themeColors.basic.main) : undefined,
      backgroundColor: pageSectionBackgroundColor
    });
    return {
      ccPage: ccPage,
      ccPageSection: ccPageSection
    };
  }, [fontFamily, basicFontSize, pxToRem, isMobileView, withPageSectionSeparator, pageSectionBackgroundColor, themeColors === null || themeColors === void 0 ? void 0 : themeColors.basic.main]);
  return {
    'cc-Page': ccPageStyle.ccPage,
    'cc-PageSection': ccPageStyle.ccPageSection
  };
};
exports.useStyles = useStyles;
var _default = useStyles;
exports.default = _default;